<template>
  <input :value="label" type="button" @click="_click"/>
</template>

<script>
export default 
{ name: 'Button',
 
  emits: ['click'],

  props:
  { label: String },

  methods:
  { _click()
    { this.$emit('click') }
  },
}
</script>
